<nz-form-label [nzSpan]="24">{{config.name}}</nz-form-label>
<nz-upload [nzAccept]='acceptType'>
  <button nz-button><i nz-icon nzType="upload"></i><span>{{config.title}}</span></button>
</nz-upload>